import { render } from "./ChangeNotification.vue?vue&type=template&id=de843938&ts=true"
import script from "./ChangeNotification.vue?vue&type=script&lang=ts"
export * from "./ChangeNotification.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__